import { memo } from 'react';

import { Delivery } from '../../lib/types';
import { MainButton } from '../buttons';
import { Popup } from '../modal';

interface ExistingCartProps {
  delivery: Delivery;
  relationship: string;
  showing: boolean;
  onStartNew: () => void;
  onDismiss: () => void;
}

const ExistingCart: React.FC<ExistingCartProps> = ({ delivery, relationship, showing, onStartNew, onDismiss }) => {
  let existingText = 'another relationship';
  if (delivery && delivery.relationship) {
    existingText = delivery.relationship.name;
  }

  return (
    <Popup onDismiss={onDismiss} size="partial" showing={showing}>
      <div className="relative flex flex-col h-full">
        <div className="mx-4 grid grid-cols-3 items-center mt-6">
          <img src="/images/x-black.png" className="w-4 h-4 cursor-pointer" alt="dismiss" onClick={onDismiss} />
        </div>

        <div className="mx-4 mt-4 flex flex-col flex-1">
          <p className="text-2xl font-medium text-center">Start a new cart?</p>

          <p className="text-center mx-4 lg:mx-6 mt-4">
            You currently have items in your cart from <span className="text-pink-400 font-medium">{existingText}</span>
            . Would you like to clear the cart and add new items from{' '}
            <span className="text-pink-400 font-medium">{relationship}</span>?
          </p>

          <div className="flex items-center w-full mt-auto lg:mt-8 mb-5 lg:mb-6">
            <MainButton color="bg-gray-400" className="flex-1 mr-2 lg:ml-2" onClick={onDismiss} title="Cancel" />
            <MainButton className="flex-1 ml-2 lg:mr-2" onClick={onStartNew} title="New Cart" />
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default memo(ExistingCart);
